import { Button, makeStyles, Typography } from "@material-ui/core";
import React, { useState, useEffect, useMemo } from "react";
import DynamicTitle from "../../component/DynamicTitle";
import { HeadCard } from "./component/HeadCard";
import { LaunchTo, NavTo } from "../../utils/AppManager";
import { Path } from "../../utils/Constant";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { actions as BillerAction } from "../../store/redux/BillerRedux";
import { BillerModel, initBillerModel } from "../../models/BillerModel";
import TemplateComponent from "../../component/template/TemplateComponent";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import { fontUnit, padGinUnit } from "../../utils/DeviceManager";
import { DeeplinkReqModel } from "../../models/QrBarCodeModel";
import { ApiConfig, Service, ServiceApi } from "../../service/ServiceApi";
import axios from "axios";
import { PaymentCardSlider } from "./component/PaymentCardSlider/PaymentCardSlider";
import { CurrencyInput } from "./component/CurrencyInput";

let displayValue = "";
let selectedPayType = "";

const data = [
    { title: 'SCB Easy', isfee: false, image: 'scb' },
    { title: 'QR/Barcode', isfee: true, image: 'qrcode' },
    { title: 'แอปฯ ธนาคารอื่น', isfee: true, image: 'other' }
];

export function ChooseChannel({ location }: any) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [billInfo] = useSelector((state: RootState) => [
        state.billerReducer.billInfo,
    ]);
    const [bill, setBill] = useState<BillerModel>(initBillerModel())
    const params = new URLSearchParams(location.search);

    const [isFirst, setIdFirst] = useState(true);
    const No_SERVICE = "ขออภัย ไม่สามารถแสดงผลลัพธ์ได้ในขณะนี้ กรุณาลองอีกครั้ง"; //TLMSIT-7550
    const INSURANCE_REMARK_TEXT = "*ความคุ้มครองตามกรมธรรม์ของท่านจะสิ้นสุด หากไม่ชำระค่าเบี้ยภายใน 15 วันจากวันที่กำหนด";
    const PAID_REMARK_TEXT = "*การจ่ายขั้นต่ำจะทำให้ท่านต้องเสียดอกเบี้ยมากขึ้นและเป็นหนี้นาน ถ้าจ่ายมากกว่าขั้นต่ำจะช่วยลดดอกเบี้ยและปิดหนี้เร็วขึ้น";
    // const [selectedPayType, setSelectedPayType] = useState("full"); // full , custom
    const [isAmountDisable, setIsAmountDisable] = useState(true);
    const [isMinimumFirstTime, setIsMinimumFirstTime] = useState(true);
    const [isInputLessThanMin, setIsInputLessThanMin] = useState(false);
    const [channel, setChannel] = useState(""); // other, scb, qrcode
    const [isInputFocused, setIsInputFocused] = useState(false);

    const [displayAmount, setDisplayAmount] = useState("");

    useEffect(() => {
        if (parseFloat(bill.fullAmount) > 0) {
            // setSelectedPayType("full");
            selectedPayType = "full";
            setIsAmountDisable(true);
        } else if (parseFloat(bill.minimumAmount) > 0) {
            // setSelectedPayType("minimum");
            selectedPayType = "minimum";
            setIsAmountDisable(true);
        } else {
            // setSelectedPayType("custom");
            selectedPayType = "custom";
            setIsAmountDisable(false);
        }
    }, [])


    const prepareData = () => {
        window.document.title = "ชำระเงิน"
        const billerCodeId = replaceData(String(params.get('billerCodeId')))
        const ref1 = replaceData(String(params.get('ref1')))
        const ref2 = replaceData(String(params.get('ref2')))
        const registeredNumber = replaceData(String(params.get('registeredNumber')))
        const fullAmount = replaceData(String(params.get('fullAmount')))
        const minimumAmount = replaceData(String(params.get('minimumAmount')))
        const loanType = replaceData(String(params.get('type')))
        const accountTypeName = replaceData(String(params.get('typeName')))
        const paymentDate = replaceData(String(params.get('paymentDate')))
        const passdueDay = replaceData(String(params.get('passdueDay')))
        const paymentTerm = replaceData(String(params.get('paymentTerm')))
        const chargeAmount = replaceData(String(params.get('otherAmount')))
        const overDueStatus = replaceData(String(params.get('overDue')))
        const billAmount = replaceData(String(params.get('billAmount')))
        const loanGruop = replaceData(String(params.get('loanGroup')))
        var full = CurrencyInput(fullAmount);
        if (parseFloat(fullAmount) > 0) {
            setDisplayAmount(full);
        }

        if (ref1.length <= 1) {
            NavTo(Path.expired)
        }

        const billerModel: BillerModel = {
            billerCodeId: billerCodeId,
            ref1: ref1,
            ref2: ref2,
            registeredNumber: registeredNumber,
            loanType: loanType,
            accountTypeName: accountTypeName,
            fullAmount: fullAmount,
            minimumAmount: minimumAmount,
            customAmount: fullAmount,
            channel: channel,
            paymentDate: paymentDate,
            passdueDay: passdueDay,
            paymentTerm: paymentTerm,
            chargeAmount: chargeAmount,
            overDueStatus: overDueStatus,
            billAmount: billAmount,
            loanGroup: loanGruop
        }
        setBill(billerModel)

        BillerAction.setBiller(dispatch, billerModel).then(() => {
            console.log("Set bill info")
        })
    }

    const replaceData = (data: string) => {
        return data
            .replace("none", "")
            .replace("null", "")
    }

    const channelData = useMemo(() => {
        if (bill.loanType === "REG1") {
          return data.filter((i) => i.image !== "other");
        } 
        return data;
    }, [bill.loanType]);

    if (isFirst) {
        setIdFirst(false)
        prepareData()
    }


    function onSelectChannel(select: string) {
        setChannel(select)
        setBill({ ...bill, channel: select })
    }

    function onSelectPayType(paytype: string) {
        selectedPayType = paytype;
        let amountCal = "";
        if (selectedPayType === "full") {
            var full = CurrencyInput(bill.fullAmount);
            setDisplayAmount(full);
            amountCal = full;
            setIsAmountDisable(true);
        }
        else if (selectedPayType === "minimum") {
            var min = CurrencyInput(bill.minimumAmount);
            setDisplayAmount(min)
            amountCal = min;
            setIsAmountDisable(true);
        }
        else {
            if (selectedPayType === "custom" && parseFloat(bill.minimumAmount) > 0) {
                var min = CurrencyInput(bill.minimumAmount);
                setIsMinimumFirstTime(true);
                setDisplayAmount("0.00")
                amountCal = min;
            } else {
                setDisplayAmount("")
                amountCal = "";
            }
            setIsAmountDisable(false);
        }

        let amount = parseFloat(amountCal.replace(/,/g, "")).toFixed(2).toString();
        setBill({ ...bill, customAmount: amount === '' || amount === 'NaN' ? "0" : amount });
    }

    const checkLessThanMinimum = (value: any) => {
        // validate minimum input
        const inputValue = parseFloat(value ? value.replace(/,/g, "") : "0")
        if (inputValue < parseFloat(bill.minimumAmount)) {
            setIsInputLessThanMin(true);
        } else {
            setIsInputLessThanMin(false);
        }
    }

    const clearInput = (e: any) => {
        setDisplayAmount("")
    }

    const handleInput = (e: any) => {
        const formattedAmount = CurrencyInput(e.target.value);
        setDisplayAmount(formattedAmount);
        var amount = parseFloat(displayAmount.replace(/,/g, "")).toFixed(2).toString();
        setBill({ ...bill, customAmount: amount === '' || amount === 'NaN' ? "0" : amount });
        checkLessThanMinimum(e.target.value)
    };

    function setAmount() {
        var amount = parseFloat(displayAmount.replace(/,/g, "")).toFixed(2).toString();
        // displayValue = CurrencyInput(amount);
        setBill({ ...bill, customAmount: amount === '' || amount === 'NaN' ? "0" : amount });
        if (displayAmount.includes('.')) {
            if ((displayAmount.split('.')[1]).length === 1) {
                setDisplayAmount(displayAmount.toLocaleString() + "0");
            } else {

                setDisplayAmount(displayAmount.toLocaleString())
            }
        } else if(!displayAmount.toLocaleString()){
           setDisplayAmount(displayAmount.toLocaleString());
        }else {
            setDisplayAmount(displayAmount.toLocaleString() + ".00");
        }

    }


    const generateDeepLink = async (bill: BillerModel) => {
        const request: DeeplinkReqModel = {
            billerCodeId: bill.billerCodeId,
            ref1: bill.ref1,
            ref2: bill.ref2,
            amount: bill.customAmount.toString(),
            channelSource: "LINE"
        }
        axios.post(ServiceApi.DEEP_LINK_GEN, request, ApiConfig)
            .then((res) => {
                return res;
            }).then(data => {
                const response = data.data

                if (data.status == 200) {
                    LaunchTo(`https://info.scb.co.th/scbeasy/easy_app_link.html?URI=${response.deeplinkUrl.toString()}&URL=${Service.DOMAIN}home`)
                } else {
                    console.log("Error with status " + data.statusText)
                    NavTo(Path.expired.replace(":msg", No_SERVICE))
                }

            })
            .catch(error => {
                const errorStr = JSON.stringify(error)
                console.log(errorStr)
                NavTo(Path.expired.replace(":msg", No_SERVICE))
            })
    }

    const onSubmit = () => {
        const amount = parseFloat(displayAmount.replace(/,/g, "")).toFixed(2).toString();
        setBill({ ...bill, customAmount: amount === '' || amount === 'NaN' ? "0" : amount });
        BillerAction.setBiller(dispatch, bill).then(() => {
            if (channel === 'other') {
                NavTo(Path.other_bank)
            } else if (channel === 'scb') {
                generateDeepLink(bill).then(() => {
                    console.log("Generating deep link")
                })
            } else if (channel === 'qrcode') {
                const req = { ...bill, customAmount: amount }
                BillerAction.setBiller(dispatch, req).then(() => {
                    NavTo(Path.qrcode)
                })
            }
        })
    }

    const chooseAmountSection = () => {
        return <div>
            <hr className={classes.sectionBreakLine} />
            <Typography className={classes.subHeader}>
                ต้องการชำระ
            </Typography>

            <div className={classes.sectionChooseAmount}>
                {
                    (Number.parseInt(bill.fullAmount, 0) > 0) ?
                        <Button className={classes.amountButton}
                            onClick={() => onSelectPayType("full")}
                            style={{
                                color: selectedPayType === "full" ? AcnColorTheme.grey50 : AcnColorTheme.darkBlue,
                                background: selectedPayType === "full" ? AcnColorTheme.darkBlue : AcnColorTheme.lightPurple,
                            }}>
                            จำนวนเต็ม
                        </Button>
                        : <div />
                }

{
                    //show minimumAmount only have value
                    (Number.parseInt(bill.minimumAmount, 0) > 0) ?
                        <Button className={classes.amountButton}
                            onClick={() => onSelectPayType("minimum")}
                            style={{
                                color: selectedPayType === "minimum" ? AcnColorTheme.grey50 : AcnColorTheme.darkBlue,
                                background: selectedPayType === "minimum" ? AcnColorTheme.darkBlue : AcnColorTheme.lightPurple,
                            }}>
                            ขั้นต่ำ
                        </Button>
                        : <div />
                }

                {
                    !(bill.loanType === "REG1") ?
                        <Button className={classes.amountButton}
                            onClick={() => onSelectPayType("custom")}
                            style={{
                                color: selectedPayType === "custom" ? AcnColorTheme.grey50 : AcnColorTheme.darkBlue,
                                background: selectedPayType === "custom" ? AcnColorTheme.darkBlue : AcnColorTheme.lightPurple,
                            }}>
                            ระบุจำนวน
                        </Button>
                        : <div />
                }


            </div>
            <div className={classes.sectionChooseAmount}>
                <input
                    value={displayAmount}
                    placeholder="0.00"
                    className={classes.amountInput}
                    onFocus={(e) => {
                        clearInput(e);
                        setIsInputFocused(true);
                      }}
                    onClick={() => setIsMinimumFirstTime(false)}
                    onChange={handleInput}
                    onBlur={(e) => {
                        setAmount();
                        setIsInputFocused(false);
                      }}
                    disabled={isAmountDisable}
                    inputMode="decimal"
                    style={{
                        background: selectedPayType === "custom" && parseFloat(bill.minimumAmount) > 0
                            ? isInputFocused
                                ? AcnColorTheme.lightPurple
                                : isMinimumFirstTime
                                ? AcnColorTheme.lightPurple
                                : ''
                            : '',
                        borderColor:
                            selectedPayType === 'custom' && parseFloat(bill.minimumAmount) > 0
                              ? isInputLessThanMin && !isMinimumFirstTime
                                ? AcnColorTheme.secondaryRed
                                : isInputFocused || isMinimumFirstTime
                                ? AcnColorTheme.primaryPurple
                                : AcnColorTheme.lightGrey
                              : AcnColorTheme.lightGrey,
                        outline: 'none',
                    }}
                />
            </div>

            {
                parseFloat(billInfo.minimumAmount) > 0 && selectedPayType === "custom" ?
                    <Typography
                        className={classes.minimumAmountRemarkText}
                        style={{
                            color: isMinimumFirstTime ?
                                AcnColorTheme.darkGrey
                                : isInputLessThanMin ?
                                    AcnColorTheme.secondaryRed : AcnColorTheme.darkGrey
                        }}>
                        จำนวนขั้นต่ำ  {CurrencyInput(billInfo.minimumAmount)}
                    </Typography>
                    : <div />
            }

            <div className={classes.remarkBox}>
                <Typography className={classes.remarkText}>{PAID_REMARK_TEXT}</Typography>
            </div>

            {bill.loanType === 'INSI' && bill.overDueStatus === "true" ?
                <Typography className={classes.insuranceRemarkText}>
                    {INSURANCE_REMARK_TEXT}
                </Typography>
                : <div />
            }

            <div style={{ height: '300px' }} />
        </div>
    }

    const chooseChannelWidget = () => {
        return (
            <div className={classes.rootApp}>
                <div className={classes.header}>
                    <DynamicTitle title={"ชำระเงิน"} isFull={true} size={fontUnit(24)} />
                </div>
                <div className={classes.content}>
                    <div className={classes.paddingContainer}>
                        <HeadCard
                            loanGroup={bill.loanGroup}
                            accountTypeName={bill.accountTypeName}
                            registeredNumber={bill.registeredNumber}
                        />

                        <hr className={classes.sectionBreakLine} />
                    </div>
                    <div className={classes.paddingContainer}>
                        <Typography className={classes.subHeader}>
                            ช่องทางชำระเงิน
                        </Typography>
                    </div>
                    <div style={{ paddingLeft: padGinUnit(24) }}>
                        <PaymentCardSlider
                            channelData={channelData}
                            channel={channel}
                            callBackOnSelectChannel={onSelectChannel}
                        />
                    </div>
                    <div style={{ height: '56px' }} />

                    <div className={classes.paddingContainer}>
                        {channel && !(channel === "other") ?
                            chooseAmountSection()
                            : <div />
                        }
                    </div>
                </div>
                <div style={{ height: '110px' }} />
            </div>
        );
    }

    return (
        <TemplateComponent content={chooseChannelWidget()}
            onNext={onSubmit}
            isCanNext={(channel != "" && parseFloat(bill.customAmount.replace(/,/g, "")) > 0) || channel === "other"}
            nextText={"ยืนยัน"}
            btnBackground={AcnColorTheme.ghostWhite}
            background={AcnColorTheme.ghostWhite}
            noPadding={true}
        />
    );
}

const useStyles = makeStyles({
    rootApp: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        overflowY: "auto",
        overflowX: "hidden",
        fontFamily: "Prompt"
    },
    paddingContainer: {
        paddingLeft: padGinUnit(24),
        paddingRight: padGinUnit(24)
    },
    header: {
        display: 'flex',
        marginBottom: 40,
        paddingTop: padGinUnit(24),
        paddingLeft: padGinUnit(24),
        paddingRight: padGinUnit(24)
    },
    subHeader: {
        color: AcnColorTheme.black,
        padding: '16px 0',
        textAlign: "start",
        fontSize: fontUnit(16),
        fontWeight: 'bold',
    },
    content: {
        alignItems: 'center',
    },
    sectionBreakLine: {
        color: AcnColorTheme.lightGrey,
        // margin: '16px 0'
    },
    sectionChooseChannel: {
        display: 'flex',
        flexDirection: 'row',
        overflowY: 'auto'
    },
    sectionChooseAmount: {
        display: 'flex',
    },
    amountButton: {
        fontFamily: 'Prompt-Regular',
        fontWeight: 400,
        fontSize: fontUnit(16),
        color: AcnColorTheme.darkBlue,
        alignItems: 'center',
        justifyContent: 'center',
        border: '0px',
        borderRadius: '16px',
        background: AcnColorTheme.lightPurple,
        padding: '4px 12px',
        marginRight: 8,
    },
    amountInput: {
        width: '100%',
        fontFamily: 'Prompt-Medium',
        fontWeight: 'normal',
        fontSize: fontUnit(16),
        textAlign: 'end',
        border: '1px solid',
        borderRadius: '8px',
        padding: 16,
        marginTop: 16,
    },
    insuranceRemarkText: {
        fontSize: fontUnit(14),
        color: AcnColorTheme.secondaryRed,
        padding: '2px 0px',
        textAlign: "left"
    },
    minimumAmountRemarkText: {
        fontSize: fontUnit(14),
        padding: '2px 16px',
        textAlign: "left"
    },
    remarkBox: {
        marginTop: '16px',
    },
      remarkText: {
        color: AcnColorTheme.secondaryRed,
        textAlign: 'start',
        fontSize: fontUnit(14),
    },
},
    { name: 'ChooseChannel' });